import * as React from 'react';

function SvgProgressSelectingPaymentPlan(props) {
  return (
    <svg viewBox="0 0 18 18" xmlns="http://www.w3.org/2000/svg" {...props}>
      <g clipPath="url(#progress-selecting-payment-plan_svg__a)">
        <path d="M16.393.967H1.608a.642.642 0 00-.643.643v14.785c0 .356.287.643.643.643H8.84a.16.16 0 00.16-.16v-1.126a.161.161 0 00-.16-.16H2.41V2.413h13.18v6.429c0 .088.072.16.16.16h1.126a.16.16 0 00.16-.16V1.61a.642.642 0 00-.643-.643zm-4.554 9.791l1.049-1.048a.16.16 0 00-.013-.239.161.161 0 00-.082-.035L9.19 9.015a.161.161 0 00-.178.178l.421 3.604a.161.161 0 00.274.095l1.052-1.053 5.147 5.147a.161.161 0 00.227 0l.852-.852a.161.161 0 000-.227l-5.145-5.149z" />
      </g>
      <defs>
        <clipPath id="progress-selecting-payment-plan_svg__a">
          <path fill="#fff" d="M0 0h18v18H0z" />
        </clipPath>
      </defs>
    </svg>
  );
}

export default SvgProgressSelectingPaymentPlan;
